import * as z from "zod";

export const ReceiverSchema = z.object({
  Name: z.string(),
  Document: z.string(),
  AvatarUrl: z.url().nullable(),
});
